// extracted by mini-css-extract-plugin
export var grid = "_2q-0";
export var span1 = "_2q-2";
export var span10 = "_2q-b";
export var span10L = "_2q-z";
export var span10M = "_2q-n";
export var span10Xl = "_2q-1b";
export var span11 = "_2q-c";
export var span11L = "_2q-10";
export var span11M = "_2q-o";
export var span11Xl = "_2q-1c";
export var span12 = "_2q-d";
export var span12L = "_2q-11";
export var span12M = "_2q-p";
export var span12Xl = "_2q-1d";
export var span1L = "_2q-q";
export var span1M = "_2q-e";
export var span1Xl = "_2q-12";
export var span2 = "_2q-3";
export var span2L = "_2q-r";
export var span2M = "_2q-f";
export var span2Xl = "_2q-13";
export var span3 = "_2q-4";
export var span3L = "_2q-s";
export var span3M = "_2q-g";
export var span3Xl = "_2q-14";
export var span4 = "_2q-5";
export var span4L = "_2q-t";
export var span4M = "_2q-h";
export var span4Xl = "_2q-15";
export var span5 = "_2q-6";
export var span5L = "_2q-u";
export var span5M = "_2q-i";
export var span5Xl = "_2q-16";
export var span6 = "_2q-7";
export var span6L = "_2q-v";
export var span6M = "_2q-j";
export var span6Xl = "_2q-17";
export var span7 = "_2q-8";
export var span7L = "_2q-w";
export var span7M = "_2q-k";
export var span7Xl = "_2q-18";
export var span8 = "_2q-9";
export var span8L = "_2q-x";
export var span8M = "_2q-l";
export var span8Xl = "_2q-19";
export var span9 = "_2q-a";
export var span9L = "_2q-y";
export var span9M = "_2q-m";
export var span9Xl = "_2q-1a";
export var stretch = "_2q-1";